import React, { useEffect, useState } from "react";
import BasedModal, {
    IProps as ModalProps,
} from "../BaseModalComponents/BasedModal";
import {
    ModalTitle,
    ModalDescription,
} from "components/AreYouSureModal/areYouSureModalStyles";
import { Container, ModalBody } from "components/NewGroupModal/styles";
import { getCellBackgroundWithErrorFlag } from "components/BasedTable/basedTableStyles";
import { useDispatch } from "react-redux";
import { initColorsFilter } from "store/reducers/FilterSlice";
import { useAppSelector } from "hooks/redux";
import { Button } from "antd";
import { sendSectionCommand } from "store/reducers/TabsSlice";
import { RealModeTimerModal } from "components/RealModeTimerModal/RealModeTimerModal";

const bodyStyle = {
    paddingTop: 15,
    fontSize: 20,
    fontWeight: "bold",
    alignItems: "center",
    width: "400px",
    marginBottom: 15,
};

const COMMANDS = [
    // { label: "Перезагрузить с переподпиской", cmd: "RRO", disabled: false },
    { label: "Перезагрузить без переподписки", cmd: "RT", disabled: false },
    { label: "Перевод в бой ", cmd: "WT", disabled: false },
    { label: "Перевод в вирт", cmd: "VT", disabled: false },
    { label: "Перевод в закрытие", cmd: "SCT", disabled: false },
    { label: "Отменить в закрытие", cmd: "CCT", disabled: false },
    { label: "Выставить АЗ для всех стратегий", cmd: "SAT", disabled: false },

    { label: "Перевод в real режим", cmd: "SRT", disabled: false },
    { label: "Отмена перевода в real режим", cmd: "CRT", disabled: false },
    // { label: "Отменить счетчик АЗ", cmd: "RA", disabled: false },
    // { label: "Получить путь к папке с конфигами", cmd: "SP", disabled: false },
];

interface IProps extends ModalProps {
    onRequestClose: () => void;
}

function TickersCommandsModal({
    isOpen,
    title,
    description,
    onRequestClose,
    id,
    onApplyClick,
}: IProps) {
    const dispatch = useDispatch();
    const checkboxValues = useAppSelector((state) => state.filter.colors[id]);
    const [isRealModeTimerOpened, setIsRealModeTimerOpened] = useState(false);

    useEffect(() => {
        if (!checkboxValues) dispatch(initColorsFilter({ id: id }));
    }, []);

    const onCommandClick = (cmd) => {
        if (cmd === "SRT") {
            setIsRealModeTimerOpened(true);
            return;
        }
        dispatch(
            sendSectionCommand({
                section_id: id,
                command: cmd,
            }),
        );

        onRequestClose();
    };

    const handleRealModeConfirm = (scheduledTime: string | null) => {
        dispatch(
            sendSectionCommand({
                section_id: id,
                command: "SRT",
                additionalData: { run_at: scheduledTime },
            }),
        );
        setIsRealModeTimerOpened(false);
        onRequestClose();
    };

    return (
        <>
            <RealModeTimerModal
                tickerName={null}
                isSection={true}
                sectionId={id}
                isOpen={isRealModeTimerOpened}
                onRequestClose={() => setIsRealModeTimerOpened(false)}
                onConfirm={handleRealModeConfirm}
            />
            <BasedModal isOpen={isOpen} onRequestClose={onRequestClose}>
                <Container id="tickers_commands">
                    <ModalBody style={bodyStyle as object}>
                        <ModalTitle>{title}</ModalTitle>
                        {description && (
                            <ModalDescription>{description}</ModalDescription>
                        )}
                    </ModalBody>

                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: 5,
                        }}
                    >
                        {COMMANDS.map((command) => (
                            <Button onClick={() => onCommandClick(command.cmd)}>
                                {command.label}
                            </Button>
                        ))}
                    </div>
                </Container>
            </BasedModal>
        </>
    );
}

export default TickersCommandsModal;
